<app-redirect-animation></app-redirect-animation>